module.exports = __webpack_public_path__ + "img/35400.f4b1beb9.jpg";